import {
  Avatar,
  Box,
  Button,
  Chip,
  CircularProgress,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'
import React, { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import ConfirmationBox from 'src/Component/ConfirmationBox'
import SimpleModal from 'src/Component/SimpleModal'
import { useGetParkByIdQuery } from 'src/api/manageParksApi'
import { AppDispatch } from 'src/store'
import { startPageLoader, stopPageLoader } from 'src/store/features/common/commonSlice'
import useEditPark from './useEditPark'
import InputField from 'src/Component/InputField'
import { Controller } from 'react-hook-form'
import FileInput from 'src/Component/FileInput'
import editIconRedBg from 'src/assets/icons/editIconRedBg.png'
type EditParkModalProps = {
  id: number
  open: boolean
  onClose: () => void
  successCallback: () => void
  onDeleteClick: (id: number) => void
}
const EditParkModal = ({
  id,
  open,
  onClose,
  successCallback,
  onDeleteClick,
}: EditParkModalProps) => {
  const {
    file,
    handleFileChange,
    control,
    errors,
    onSubmit,
    isLoadingEditPark,
    imageUrl,
    showUploadImage,
    handleShowUploadImage,
  } = useEditPark({
    successCallback,
    id,
  })

  return (
    <Box>
      <SimpleModal open={open} onClose={onClose}>
        <form onSubmit={onSubmit}>
          <Box>
            {showUploadImage || !imageUrl ? (
              <FileInput
                type='image'
                title='You can click me to upload files!'
                discription='Support for  image file formats (.png, .jpeg)'
                name='fileuplaod'
                value={file}
                onChange={handleFileChange}
                showPreview
              />
            ) : (
              <Box textAlign='center' position='relative' minHeight='50px'>
                <img
                  src={imageUrl}
                  style={{
                    height: '250px',
                    objectFit: 'cover',
                  }}
                />
                <Box
                  sx={{
                    position: 'absolute',
                    right: 0,
                    bottom: 0,
                  }}
                >
                  {' '}
                  <IconButton onClick={handleShowUploadImage}>
                    <img src={editIconRedBg} />
                  </IconButton>
                </Box>
              </Box>
            )}

            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='name'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Name'
                        placeholder='Enter park name'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.name}
                        required
                      />
                      {!!errors.name && (
                    <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                          {errors.name.message}
                        </Typography>
                    </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='address'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='Address'
                        placeholder='Enter park address'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.address}
                        required
                      />
                      {!!errors.address && (
                      <Grid container justifyContent='right' >
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                          {errors.address.message}
                        </Typography>
                      </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container mt={3}>
              <Grid xs={8} mb={2}>
                <Controller
                  name='about'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='text'
                        label='About'
                        placeholder='Enter about park'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.about}
                        required
                        multiline
                        rows={3}
                      />
                      {!!errors.about && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.about.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='latitude'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Latitude'
                        placeholder='Enter park latitude'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.latitude}
                        required
                      />
                      {!!errors.latitude && (
                       <Grid container justifyContent='right'>
                         <Typography variant='subtitle2' color='red' textAlign='right'>
                          {errors.latitude.type === 'typeError'
                            ? 'Latitude shoule be number'
                            : errors.latitude.message}
                        </Typography>
                       </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>

            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='longitude'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='number'
                        regex={/[^0-9]*$/}
                        label='Longitude'
                        placeholder='Enter park longitude'
                        value={field.value === 0 ? '' : field.value}
                        onChange={field.onChange}
                        // error={!!errors.longitude}
                        required
                      />
                      {!!errors.longitude && (
                      <Grid container justifyContent='right' >
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                          {errors.longitude.type === 'typeError'
                            ? 'Longitude shoule be number'
                            : errors.longitude.message}
                        </Typography>
                      </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='open'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='time'
                        label='Open At'
                        placeholder='Enter the Time'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.open}
                        required
                      />
                      {!!errors.open && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.open.type === 'typeError'
                              ? 'open shoule be number'
                              : errors.open.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Grid container>
              <Grid xs={8} mb={2}>
                <Controller
                  name='close'
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <>
                      <InputField
                        name={field.name}
                        type='time'
                        label='Close At'
                        placeholder='Enter the Time'
                        value={field.value}
                        onChange={field.onChange}
                        // error={!!errors.close}
                        required
                      />
                      {!!errors.close && (
                        <Grid container justifyContent='right'>
                          <Typography variant='subtitle2' color='red' textAlign='right'>
                            {errors.close.type === 'typeError'
                              ? 'close shoule be number'
                              : errors.close.message}
                          </Typography>
                        </Grid>
                      )}
                    </>
                  )}
                />
              </Grid>
            </Grid>
            <Button
              variant='contained'
              color='secondary'
              type='submit'
              disabled={isLoadingEditPark}
            >
              {isLoadingEditPark ? <CircularProgress size={25} color='error' /> : 'SAVE'}
            </Button>
            <Button
              onClick={() => onDeleteClick(id)}
              sx={{ marginLeft: '20px' }}
              variant='contained'
              color='primary'
              type='button'
            >
              DELETE
            </Button>
          </Box>
        </form>
      </SimpleModal>
    </Box>
  )
}

export default EditParkModal
